import { render, staticRenderFns } from "./RelatorioLogPerfilTurmaEscrita.vue?vue&type=template&id=5bf0bde4"
import script from "./RelatorioLogPerfilTurmaEscrita.vue?vue&type=script&lang=js"
export * from "./RelatorioLogPerfilTurmaEscrita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports